module.exports = __webpack_public_path__ + "img/drive-viewer-panel-3.c1ec0809.svg";